module.exports = __webpack_public_path__ + "img/video-preview-2x.062e6f0.jpg";